export default __webpack_public_path__ + "static/media/597.8f48759f.gif";